import { useQuery } from 'data-fetching-client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { GET_ACTIVE_QUOTES } from 'pricing-pages-api/quotes/queries';
import { getActiveQuoteUrl, handleRedirect } from 'pricing-pages-lib/utils/urls';
import { APP } from 'pricing-pages-ui/constants/AuthType';
import { getRelevantQuote } from 'pricing-pages-ui/utils/getRelevantQuote';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ProductLineMap from 'self-service-api/constants/ProductLineMap';
import { REQUEST_QUOTE } from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import { BILLING } from 'ui-addon-upgrades/_core/common/constants/AdminTypes';
import UIAdminOnlyWrapper from 'ui-addon-upgrades/decorators/UIAdminOnlyWrapper';
import { allProductVersionsSelector, productSelector } from '../../selectors/ProductsSelectors';
import { trackBannerInteraction } from '../../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ActiveQuoteBanner = ({
  productLine,
  screen // for unit testing purposes
}) => {
  const {
    data,
    loading
  } = useQuery(GET_ACTIVE_QUOTES);
  const activeQuotes = (data === null || data === void 0 ? void 0 : data.activeQuotes) || [];
  const [visible, setVisible] = useState(loading);
  const uniqueId = 'active-quote-banner';
  useEffect(() => {
    if (!loading) {
      setVisible(true);
      trackBannerInteraction({
        action: 'view',
        name: 'active-quote-banner'
      });
    }
  }, [loading]);
  const handleClickQuote = relevantQuote => {
    trackBannerInteraction({
      action: 'click',
      name: 'active-quote-banner'
    });
    handleRedirect(getActiveQuoteUrl(relevantQuote.publicId));
  };
  const handleDismiss = () => {
    trackBannerInteraction({
      action: 'dismiss',
      name: 'active-quote-banner'
    });
    setVisible(false);
  };
  const allSkuIdsInProductLine = useSelector(state => Object.values(allProductVersionsSelector(state)).filter(({
    productId
  }) => {
    const product = productSelector(state, {
      productId
    });
    return product && product.productLine === productLine;
  }).map(({
    skuId
  }) => skuId));
  if (!visible) return null;
  const relevantQuote = getRelevantQuote(activeQuotes, allSkuIdsInProductLine);
  if (!relevantQuote) return null;
  return /*#__PURE__*/_jsx(Alert, {
    "data-selenium-id": "active-quote-banner",
    type: "info",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "activeQuote.title"
    }),
    children: /*#__PURE__*/_jsxs(ButtonWrapper, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "activeQuote.text"
      }), /*#__PURE__*/_jsx(UIAdminOnlyWrapper, {
        adminType: BILLING,
        modalType: REQUEST_QUOTE,
        productLine: productLine,
        upgradeData: {
          app: APP,
          screen,
          upgradeProduct: ProductLineMap[productLine].upgradeProduct,
          uniqueId
        },
        children: /*#__PURE__*/_jsx(Button, {
          use: "tertiary",
          size: "extra-small",
          onClick: () => handleClickQuote(relevantQuote),
          "data-selenium-id": "active-quote-purchase-button",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "activeQuote.link"
          })
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        size: "extra-small",
        onClick: handleDismiss,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "activeQuote.dismiss"
        })
      })]
    })
  });
};
export default ActiveQuoteBanner;